import { z } from 'zod'
import { atom } from 'jotai'
import { atomWithSessionStorage } from '../useStorage/atomsWithStorages'
import { MFRM_UNIFY_CLIENTELING_TAB_NAME } from '../conventions'

const INITIAL_TAB = '/clienteling/newleads'

export const clientelingTabAtom = atomWithSessionStorage(MFRM_UNIFY_CLIENTELING_TAB_NAME, INITIAL_TAB, z.string())

export const resetClientelingTabAtom = atom(null, (_, set) => {
  set(clientelingTabAtom, INITIAL_TAB)
})
